import React, { useRef, useState } from "react";
import { Topbar } from "../../components/include/Topbar";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { useLocation} from "react-router-dom";
import { useDispatch } from "react-redux";
import pdfIcon from "../../assets/Icons/pdf.svg";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const Add_Note = () => {
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const fileInputRef = useRef();

  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    files: [],
  });

  const [errors, setErrors] = useState({});
  const type = location.state?.type;

  console.log(type, "TYPE");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.subject) newErrors.subject = true;
    if (!formData.description) newErrors.description = true;
    if (formData.files.length === 0) newErrors.files = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    // const pdfFiles = selectedFiles.filter(
    //   // (file) => file.type === "application/pdf"
    // );

    // if (pdfFiles.length !== selectedFiles.length) {
    //   alert("Only PDF files are allowed.");
    // }

    setFormData((prev) => ({
      ...prev,
      files: [...prev.files, ...selectedFiles],
    }));

    // Clear the input so same file can be selected again
    if (fileInputRef.current) fileInputRef.current.value = null;
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...formData.files];
    updatedFiles.splice(index, 1);
    setFormData((prev) => ({ ...prev, files: updatedFiles }));
  };

  let currentTab = "";

  if (type === "Note") {
    currentTab = "Notes";
  } else if (type === "File") {
    currentTab = "Files";
  } else if (type === "Contribution") {
    currentTab = "Contribution";
  }

  const handleSubmit = () => {
    if (!validate()) return;

    const form = new FormData();
    if (type === "Note") {
      form.append("subject", formData.subject);
    } else {
      form.append("title", formData.subject); // type = "File" || "Contribution"
    }
    form.append("description", formData.description);
    form.append("board_member_id", location.state.member_id);
    for (let i = 0; i < formData.files.length; i++) {
      form.append("file", formData.files[i]);
    }
    // formData.files.forEach(
    //   (file, index) => form.append(`file[${index}]`, file)
    // );

    let apiUrl = "";

    if (type === "Note") {
      apiUrl = HttpService.board_notes_add;
    } else if (type === "Contribution") {
      apiUrl = HttpService.board_contributions_add;
    } else {
      apiUrl = HttpService.board_files_add;
    }

    Postdata(apiUrl, form).then((res) => {
      if (res.status === 200) {
        navigate(`board-management/view/${location.state.member_id}`, {
          replace: true,
          state: { currentTab },
        });
      }
      dispatch(message(res.message));
    });

    console.log(formData, "form----");
  };

  return (
    <>
      <Topbar title={`Add ${type}`} aerrow={true} currentTab={currentTab} />
      <div className="max-w-6xl  mx-auto bg-gray-100 p-6 rounded-xl space-y-6">
        {/* Profile Picture */}
        {/* <div className="flex flex-col items-center">
          <label className="flex flex-col items-center justify-center w-24 h-24 rounded-full border-2 border-purple-500 cursor-pointer overflow-hidden">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
            />
            {previewURL ? (
              <img
                src={previewURL}
                alt="Preview"
                className="w-full h-full object-cover rounded-full"
              />
            ) : (
              <span className="text-purple-500 text-3xl">📷</span>
            )}
          </label>
          <span className="text-sm mt-2 text-gray-700 font-medium">
            Upload Profile Picture <span className="text-red-500">*</span>
          </span>
          {errors.profilePicture && (
            <span className="text-red-500 text-sm">Required</span>
          )}
        </div> */}

        {/* Inputs */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700">
              {type === "Note" ? " Subject Name" : "Title"}{" "}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="subject"
              placeholder="Enter Subject Name"
              className="input-field"
              value={formData.subject}
              onChange={handleInputChange}
            />
            {errors.memberName && (
              <span className="text-red-500 text-sm">Required</span>
            )}
          </div>

          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1">
              Upload File <span className="text-red-500">*</span>
            </label>

            <div className="flex items-center gap-4">
              {/* Fake Input and Upload Button */}
              <div className="relative flex-1">
                <input
                  type="text"
                  placeholder="Select File"
                  className="input-field"
                  readOnly
                  //   value={pdfFile?.name || ""}
                />
                <button
                  type="button"
                  onClick={() => fileInputRef.current.click()}
                  className="absolute top-1/2 right-3 -translate-y-1/2 text-orange-600 font-semibold"
                >
                  Upload
                </button>
              </div>

              {/* Hidden File Input */}
              <input
                type="file"
                ref={fileInputRef}
                name="files"
                multiple
                accept=".pdf"
                onChange={handleFileChange}
                className="hidden"
              />
            </div>
            {errors.files && (
              <p className="text-red-500 text-sm mt-1">
                At least one PDF is required
              </p>
            )}
          </div>

          <div className="flex flex-wrap gap-2">
            {/* PDF Preview */}
            {formData.files.map((file, index) => (
              <div
                key={index}
                className="relative  rounded-md flex items-center justify-center"
              >
                <img src={pdfIcon} alt="PDF" className="w-10 h-10" />
                <button
                  type="button"
                  onClick={() => handleRemoveFile(index)}
                  className="absolute top-1 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Description */}
        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            name="description"
            placeholder="Write here"
            className="input-field"
            value={formData.description}
            onChange={handleInputChange}
          />
          {errors.description && (
            <span className="text-red-500 text-sm">Required</span>
          )}
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button onClick={handleSubmit} className="button-field-primary">
            Add {type}
          </button>
        </div>
      </div>
    </>
  );
};

export default Add_Note;
